import { render } from "./onPremisesTest.vue?vue&type=template&id=763f219f&scoped=true&ts=true"
import script from "./onPremisesTest.vue?vue&type=script&setup=true&lang=ts"
export * from "./onPremisesTest.vue?vue&type=script&setup=true&lang=ts"

import "./onPremisesTest.vue?vue&type=style&index=0&id=763f219f&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3807180263/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-763f219f"],['__file',"src/components/scan/onpremises/onPremisesTest.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "763f219f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('763f219f', __exports__)) {
    console.log('reload')
    api.reload('763f219f', __exports__)
  }
  
  module.hot.accept("./onPremisesTest.vue?vue&type=template&id=763f219f&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('763f219f', render)
  })

}


export default __exports__